<script setup>
import summary from 'view-design/src/components/table/summary.vue';

export default {
    props: { summary: {} },
    methods: {
        async handleViewSalary(elem) {
            this.$emit('handleViewSalary', elem);
        },
    },
};
</script>

<template>
    <div>
        <Row>
            <Col span="3">
                <Card style="width: 100%; margin-bottom: 40px">
                    <Row>
                        <Col span="3"
                            ><Row>Gross Pay</Row>
                            <Row>{{ Math.floor(summary.gross_pay) }}</Row>
                        </Col>
                    </Row>
                    <p></p>
                </Card>
            </Col>
            <Col span="3">
                <Card style="width: 100%; margin-bottom: 40px; margin-left: 20px">
                    <Row>
                        <Col span="3">
                            <Row>Total Contributions</Row>
                            <Row>{{ Math.floor(summary.total_contributions) }}</Row>
                        </Col>
                    </Row>
                    <p></p>
                </Card>
            </Col>

            <Col span="3">
                <Card style="width: 100%; margin-bottom: 40px; margin-left: 60px">
                    <Row>
                        <Col span="3">
                            <Row>Net Pay</Row>
                            <Row>{{ Math.floor(summary.net_pay) }}</Row>
                        </Col>
                    </Row>
                    <p></p>
                </Card>
            </Col>

            <Col span="3">
                <Card style="width: 100%; margin-bottom: 40px; margin-left: 80px">
                    <Row>
                        <Col span="3">
                            <Row>Total Deductions</Row>
                            <Row>{{ Math.floor(summary.total_deductions) }}</Row>
                        </Col>
                    </Row>
                    <p></p>
                </Card>
            </Col>

            <Col span="3">
                <Card style="width: 100%; margin-bottom: 40px; margin-left: 100px">
                    <Row>
                        <Col span="3">
                            <Row>Employees</Row>
                            <Row>{{ summary.employees }}</Row>
                        </Col>
                    </Row>
                    <p></p>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<style scoped lang="scss"></style>
